import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../UserContext/UserContext';

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const { userContext } = useContext(UserContext);

  // Vérifie si l'utilisateur est connecté
  const isAuthenticated = userContext !== null && userContext.isAuthenticated;

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  return isAuthenticated ? children : null;
};

export default PrivateRoute;
